<template>
  <div class="editor">
    <label :for="config.key">
      {{ config.label }}
      <sup v-if="config.required">*</sup>
    </label>
    <div class="views">
      <v-btn flat :primary="view === 'edit'" @click.native="setView('edit')">Edition</v-btn>
      <v-btn flat :primary="view === 'code'" @click.native="setView('code')">Code</v-btn>
      <v-btn flat :primary="view === 'preview'" @click.native="setView('preview')">Visualisation</v-btn>
    </div>
    <quill-editor
      v-if="view == 'edit'"
      :id="config.key"
      ref="editor"
      :content="value"
      :options="options"
      @change="onEdit($event)">
    </quill-editor>
    <textarea v-else-if="view === 'code'" class="code" :value="value" @change="e => emit(e.currentTarget.value)"></textarea>
    <div v-else-if="view === 'preview'" class="preview" v-html="value"></div>
  </div>
</template>

<script>
  import { quillEditor } from 'vue-quill-editor'
  import Quill from 'quill'
  import { mapGetters } from 'vuex'
  import input from '@/mixins/input'
  import Upload from '@/api/upload'

  const BlockEmbed = Quill.import('blots/block/embed')
  const icons = Quill.import('ui/icons')
  icons['divider'] = '<svg viewBox="0 0 18 18"><line class="ql-stroke" x1="3" x2="13" y1="14" y2="14"></line></svg>'
  class DividerBlot extends BlockEmbed {
    static blotName = 'divider'
    static tagName = 'hr'
  }
  Quill.register(DividerBlot)

  export default {
    props: {
      options: {
        type: Object,
        default: () => ({
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'font': [] }],
              [{ 'align': [] }],
              ['clean'],
              ['link', 'image', 'video'],
              ['divider']
            ]
          }
        })
      }
    },
    components: {
      quillEditor
    },
    mixins: [input],
    data () {
      return {
        view: 'edit'
      }
    },
    computed: {
      ...mapGetters({
        platform: 'skiliko/session/currentPlatform'
      }),
      editor () {
        return this.$refs.editor.quill
      }
    },
    methods: {
      setView (view) {
        this.view = view
      },
      onEdit ({ editor, html, text }) {
        this.emit(html)
      },
      addUrl (url) {
        const range = this.editor.getSelection()
        this.editor.insertEmbed(range.index, 'image', url)
      },
      selectLocalImage () {
        const input = document.createElement('input')
        input.setAttribute('type', 'file')
        input.click()

        input.onchange = () => {
          const file = input.files[0]
          if (/^image\//.test(file.type)) {
            Upload.send({
              file,
              platform: this.platform,
              path: 'content'
            })
              .then(({ data }) => this.addUrl(data.url))
          }
        }
      },
      addDivider () {
        const range = this.editor.getSelection(true)
        this.editor.insertText(range.index, '\n', Quill.sources.USER)
        this.editor.insertEmbed(range.index + 1, 'divider', true, Quill.sources.USER)
        this.editor.setSelection(range.index + 2, Quill.sources.SILENT)
      }
    },
    mounted () {
      this.editor
        .getModule('toolbar')
        .addHandler('image', this.selectLocalImage)
      this.editor
        .getModule('toolbar')
        .addHandler('divider', this.addDivider)
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../../variables"

  .editor {
    width: 100%;
    margin-bottom: 3em;

    label {
      font-size: $label-font-size;
      display: block;
      color: rgba(0,0,0,0.38);
    }
  }

  .code {
    border: solid 1px rgba(0,0,0,0.12);
    padding: 1em;
    display: block;
    width: 100%;
    height: 200px;
  }

  .preview {
    border: solid 1px rgba(0,0,0,0.12);
    padding: 1em;
  }

  .views {
    border: solid 1px rgba(0,0,0,0.12);
    margin-top: 5px;
    border-bottom: none;
    display: flex;
    flex-direction: row;

    .btn {
      margin: 0;
      border-radius: 0px;
      border-right: solid 1px rgba(0,0,0,0.12) !important;
      display: block;
    }
  }
</style>

<style>
  .ql-editor {
    min-height: 150px;
  }
  .ql-snow.ql-toolbar button, .ql-snow .ql-toolbar button {
    margin: 0;
  }
  .ql-container.ql-snow, .ql-toolbar.ql-snow {
    border-color: rgba(0,0,0,0.12);
  }
</style>



// WEBPACK FOOTER //
// src/components/inputs/RichText.vue